import { T } from '@design/index';
import { govPageContainer } from '../ui/PatientUIGovernor';
import { loadPatientIdentity } from '../utils/patientIdentity';
import type { PatientIdentity } from '../utils/patientIdentity';
import { useState, useEffect } from 'react';
import Spinner from '../../../components/ui/Spinner';

export default function PatientRegistration() {
  const [id, setId] = useState<PatientIdentity | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPatientIdentity()
      .then(({ identity }) => setId(identity))
      .finally(() => setLoading(false));
  }, []);

  if (loading || !id) return <div className="flex justify-center py-20"><Spinner size="lg" /></div>;

  const rows = [
    { label: 'Account Type', value: 'Patient', ok: true },
    { label: 'Phone Verified', value: id.phone !== 'Not set' ? id.phone : 'Not verified', ok: id.phone !== 'Not set' },
    { label: 'Email Verified', value: id.email !== 'Not set' ? id.email : 'Not verified', ok: id.email !== 'Not set' },
    { label: 'NeoHealthCard ID', value: id.nhcIdDisplay, ok: id.verifiedStatus },
    { label: 'NeoVerify ID', value: id.neoVerifyId || 'Pending', ok: !!id.neoVerifyId },
    { label: 'ABHA / ABDM', value: id.abhaId || 'Not linked', ok: !!id.abhaId },
    { label: 'Onboarding', value: 'Complete', ok: true },
  ];

  return (
    <div style={{ ...govPageContainer({ maxWidth: 440 }), display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, boxShadow: T.shadow }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: T.text, fontFamily: T.font, marginBottom: 12 }}>Registration &amp; Verification</div>
        {rows.map((r, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderTop: i > 0 ? `1px solid ${T.borderLight}` : 'none' }}>
            <span style={{ fontSize: 11, color: T.textSec, fontFamily: T.font }}>{r.label}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: T.text, fontFamily: T.font, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.value}</span>
              <div style={{ width: 8, height: 8, borderRadius: 4, background: r.ok ? T.success : T.warning }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ background: `${T.teal}08`, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: T.text, fontFamily: T.font, marginBottom: 4 }}>Identity Verification</div>
        <div style={{ fontSize: 10, color: T.textSec, fontFamily: T.font, lineHeight: 1.6 }}>
          Your NeoHealthCard identity is verified through NeoVerify. ABHA / ABDM linking is optional and can be completed through the Health IDs section in Edit Profile.
        </div>
      </div>
    </div>
  );
}
